// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1ztIK","title":"styles_title__3TQgf"};